// extracted by mini-css-extract-plugin
export var li = "_vc-2";
export var ol = "_vc-1";
export var ul = "_vc-0";